// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3GnZc","footer":"ChangeClinic_footer__jYTYo"};